import React from "react";
import classNames from "classnames";
import LabelComponent from "../LabelComponent";
import { useStyles } from "./style";

const TextBoxComponent = ({
  error = "",
  label = "",
  subTitle = "",
  mandatory,
  title = "Textbox",
  className,
  extraClass,
  labelExtraIcon,
  loading,
  style,
  theme,
  tooltip,
  onChange,
  ...rest
}: any) => {
  const classes = useStyles();

  const handleChange = (event: any) => {
    const { target } = event;
    const { value, name, ...otherAttributes } = target;
    const sanitizedValue = value.replace(/[\\{}=<>$#"]+/g, "");
    const newTarget = { ...otherAttributes, value: sanitizedValue, name: name };
    onChange({ ...event, target: newTarget });
  };

  return (
    <div
      className={classNames(classes.formGrp, extraClass, "formGrpCommon exFields")}
      style={style}
    >
      {label && (
        <LabelComponent>
          {label} {mandatory && <span className="text-danger">*</span>}
          {labelExtraIcon}
        </LabelComponent>
      )}
      {subTitle && <small>{subTitle}</small>}
      <input
        maxLength={250}
        aria-label={title ? title : label}
        aria-labelledby={title ? title : label}
        title={title ? title : label}
        className={classNames(className)}
        autoComplete="off"
        onChange={handleChange}
        {...rest}
      />
      {error && <span className="text-danger f-14">{error}</span>}
    </div>
  );
};
export default TextBoxComponent;
